import validity from "./validity";
import defaultValue from "./defaultValue";
const timeStyles = {
  0: 'H:i',
  1: 'h:i K',
  2: 'H:i:S',
  3: 'i:S'
};
export const getTimeFormat = style => {
  return timeStyles[style] || timeStyles[1];
};
export default {
  validity,
  defaultValue,
  type: 'Time',
  getTimeFormat,
  timeStyles
};